import { IonCardContent } from '@ionic/react';
import { ILabourClocking } from '../../models/dms/clocking.model';
import AdhocAssetDetails from './adhocAssetDetails/AdhocAssetDetails';
import { IonCardWrapper } from './AssetDetailsCard.styles';
import FixedAssetDetails from './fixedAssetDetails/FixedAssetDetails';
import PartAssetDetails from './partAssetDetails/PartAssetDetails';
import StockUnitAssetDetails from './stockUnitAssetDetails/StockUnitAssetDetails';
import WorkshopVehicleAssetDetails from './workshopVehicleAssetDetails/WorkshopVehicleAssetDetails';

interface IComponentProps {
  labourClocking: ILabourClocking;
}

const VehicleDetailsCard: React.FC<IComponentProps> = ({ labourClocking }) => {
  return (
    <IonCardWrapper>
      <IonCardContent>
        {(() => {
          switch (labourClocking.repairOrder.vehicle?.source) {
            case 'WKV':
              return <WorkshopVehicleAssetDetails repairOrder={labourClocking.repairOrder} />;
            case 'FAS':
              return <FixedAssetDetails repairOrder={labourClocking.repairOrder} />;
            case 'VHS':
              return <StockUnitAssetDetails repairOrder={labourClocking.repairOrder} />;
            case 'PAR':
              return <PartAssetDetails repairOrder={labourClocking.repairOrder} />;
            default:
              switch (labourClocking.jobData.isAdhoc) {
                case true:
                  return <AdhocAssetDetails />;
                case false:
                  return <div>Error: Unknown RO asset</div>;
              }
          }
        })()}
      </IonCardContent>
    </IonCardWrapper>
  );
};

export default VehicleDetailsCard;
